import React, { useContext } from 'react';
import Box from 'Components/Atoms/Box';
import { Lock } from 'Components/Atoms/Icons';
import MenuItem from 'Components/Atoms/MenuItem';
import Typography from 'Components/Atoms/Typography';
import Modal from 'Components/Molecules/Modal';
import { Signature, SignatureContext } from 'Contexts/SignatureContext';

export type SignaturePromptModalProps = {
  open: boolean;
  onClose: () => void;
  onSignatureConfirmed: (signature: string) => void;
};

const SignaturePromptModal: React.FC<SignaturePromptModalProps> = ({
  open,
  onClose,
  onSignatureConfirmed,
}) => {
  const { signatures, setPincodeModalData } = useContext(SignatureContext);

  function selectSignature(s: Signature) {
    if (s.hasPin) {
      setPincodeModalData({
        type: 'validate',
        open: true,
        signatureModalData: s,
        onValidCode: () => {
          onClose();
          onSignatureConfirmed(s.signature);
        },
      });
    } else {
      onClose();
      onSignatureConfirmed(s.signature);
    }
  }

  return (
    <Modal
      open={open}
      onClose={onClose}
      title="Signature is required"
      titleTranslation="reservations"
      headerRight={null}
    >
      <Box className="column" style={{ maxHeight: '60vh', overflowY: 'auto' }}>
        {signatures.length ? (
          signatures.map((s) => (
            <MenuItem
              key={s.signature}
              value={s.signature}
              onClick={() => selectSignature(s)}
              className="flex space-between"
              translation={null}
            >
              <Box className="flex" style={{ alignItems: 'center', gap: 8 }}>
                {s.signature}
                {signatures.length > 5 && ' - ' + s.name.slice(0, 14)}
                {s.hasPin && <Lock color="inherit" />}
              </Box>
            </MenuItem>
          ))
        ) : (
          <Box
            flex
            style={{
              flexDirection: 'column',
              alignItems: 'center',
              margin: '24px 8px 16px',
              textAlign: 'center',
            }}
          >
            <Typography variant="text-4" color="subdued" translation="common">
              No Signatures available.
            </Typography>
            <Typography variant="text-4" color="subdued" translation="settings">
              Please create one in the settings.
            </Typography>
          </Box>
        )}
      </Box>
    </Modal>
  );
};

export default SignaturePromptModal;
